
import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")

const accessToken = localStorage.getItem("token")

export const get = async (sectionId) => {
    const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
    try {
      const response = await axios.get(URL_BASE+"section/get/"+sectionId, config)
      const section = response.data?.data || null;
      return section;
    } catch (error) {
      console.error("Error :", error);
      return null;
    }
  };

  

export const getList = async () => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.get(URL_BASE+"section/list", config);
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};



export const getListByFarm = async (farmId) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.get(URL_BASE+"section/list-by-farm/"+farmId, config);
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};



export const insert = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"section/insert", data, config)
    const success = response.data?.success || null;
    return success;
  } catch (error) {
    console.error("Error :", error);
    return false;
  }
};



export const update = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"section/update", data, config)
    const success = response.data?.success || null;
    return success;
  } catch (error) {
    console.error("Error :", error);
    return false;
  }
};


export const deleteSection = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"section/delete-section", data, config)
    const responseData = response.data;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};


  export default{
    get,
    getList,
    insert,
    getListByFarm,
    update,
    deleteSection
  }

